// Copyright (c) 2006-2011 David Caldwell, All Rights Reserved.

var score = require('./score'), stats = score.stats;
var lib = require('./lib'), merge=lib.merge, merge_into=lib.merge_into, srand=lib.srand, rand=lib.rand;
var dom = require('./dom'), doc=dom.doc, URL=dom.URL, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout, Cookie=dom.Cookie;
var plat = require('./platform');
var debug = require('./debug'), maybe_try=debug.maybe_try, maybe_try_wrap=debug.maybe_try_wrap, report_error=debug.report_error, bug=debug.bug;
var ajax = require('./ajax'), loadJSON=ajax.loadJSON, makeurl=ajax.makeurl;
var Alert = require('./alert');
var Prefs = require('./prefs');
var highscore = require('./highscore'), highscore_seed=highscore.highscore_seed, render_highscores=highscore.render_highscores;
var gotd = require('./gotd');
var Login = require('./login');
var prnt = require('./print'), sprintf=prnt.sprintf;

class Button {
    constructor(title, extra, onclick) {
        var disabled = extra.disabled; delete extra.disabled;
        this.div = doc.el("a",
                          merge({ onclick: (e) => { if (!this.disabled) return onclick(e); } },
                                extra),
                          this._text = doc.text(title));
        this.div.classList.add("button");
        this.enable(!disabled);
    }
    text (text) { return text == undefined ? this._text.data : this._text.data = text; }
    enable (enable) { this.div.classList.set(this.disabled = !enable, "disabled"); }
}

const PAUSE_BUTTON=1, PAUSE_BLUR=2, PAUSE_TIMEOUT=3; // Reasons why you might pause.
class seed_game {
  button(opts) {
        if (opts.if && !opts.if()) return;
        let id = opts.id || opts.name.replace(/[^A-Za-z0-9]/g, '_').toLowerCase();
        let _button = new Button(opts.name,
                                 merge({ id: id,
                                         disabled: opts.disabled },
                                       opts.key ? { accessKey: opts.key } : {},
                                       opts.title || opts.key ? { title: opts.help || `Ctrl-${opts.key}` } : {},
                                       opts.accent ? { className: "accent" } : {}),
                                 () => {
                                     maybe_try(() => opts.fn.call(this),
                                               (e) => this.report_error(`${opts.name} button`, e));
                                 });
        this[`${id}_button`] = _button;
        doc.appendTo(this.control_panel, _button.div);
  }
  seed_game_init(name, ui) {
    this.undo = [];
    this.redo = [];
    this.stats = new stats(this.name = name);

    this.activate = ui.activate;
    this.game_el = ui.game || ui.activate;
    this.control_panel = doc(['div', { id: "control_panel" } ]);
    this.game_el.parentNode.insertBefore(this.control_panel, this.game_el);

    this.alerts = [];
    var pause_enabled = this.activate;
    var game = this;
    this.instructions = doc.id("instructions");
    var buttons = [
        {name:"New Game",        fn:this.do_new_game},
        {name:"Replay",          fn:this.do_replay},
        {name:"Give Up",         fn:this.do_give_up},
        {name:"High Scores",     fn:this.do_high_scores},
        {name:"Show Rules",      fn:this.do_show_rules,                                                           if: () => this.instructions },
        {name:"Pause",           fn:this.do_pause_unpause, key:"P",                                               if: () => pause_enabled },
        {name:"Undo",            fn:this.undo_state,       key:"Z", help: "Ctrl-Z or Right-Click",                disabled: true },
        {name:"Redo",            fn:this.redo_state,       key:"E", help: "Ctrl-Shift-Z or Middle-Click",         disabled: true },
        {name:"Shuffle",         fn:this.shuffle,          key:"S",                                               if: () => this.shuffle },
        {name:"Auto-finish",     fn:this.do_auto_finish,   key:"A", help: "Ctrl-A or Left-Click (off any cards)", if: () => this.complete },
        {name:"Game Of The Day", fn:this.do_game_of_the_day, accent: true }
    ];
    buttons.forEach((b) => this.button(b));
    doc.appendTo(this.control_panel,
                 doc(["span",
                      "Game #",
                      ["input", _=>this.game_entry=_,
                       { type:"text", size: 12, id: "game", style:{display:"none"}, onchange: ()=>{
                           var seed = gotd.sane_seed(this.game_entry.value);
                           if (seed != undefined) {
                               this.push_state();
                               this.new_game(seed);
                           } else {
                               this.game_entry.value = this.old_seed;
                               this.old_seed = undefined;
                           }
                           this.game_entry.style.display="none";
                           this.game_link.style.display="inline";
                         }, onblur: ()=>{
                             this.game_entry.style.display="none";
                             this.game_link.style.display="inline";
                         }, onfocus: ()=>{
                             if (this.old_seed == undefined) this.old_seed = this.game_entry.value;
                         }, onkeydown: (event)=>{
                             var e = new plat.key_event(event);
                             if (e.key == "escape") {
                                 this.game_entry.value = this.old_seed;
                                 this.old_seed = undefined;
                                 this.game_entry.style.display="none";
                                 this.game_link.style.display="inline";
                                 return false;
                             }
                             return true;
                         }
                       }
                      ],
                      ["a", _=>this.game_link=_,
                       { href:"safari", id: "link", onclick: ()=>{
                           this.game_entry.style.display="inline";
                           this.game_link.style.display="none";
                           return false;
                       }}
                      ],
                      " ",
                      !URL.param.difficulty ? [] : ["span", _=>this.difficulty_el=_, "Difficulty"]
                     ]));

    if (pause_enabled) {
        this.activate.onmousemove = function () { this.pause(0, PAUSE_TIMEOUT); }.bind(this);
        document.onmousemove = function () { this.kick(); }.bind(this);
        plat.register_window_focus_events(function(focused) { this.pause(!focused, PAUSE_BLUR); }.bind(this));
        this.allow_pause =
        this.kick = function (enable) {
            cancel_timeout(this.pause_timeout);
            if (URL.param.pause || Cookie.list.pause)
              if (enable == undefined || enable)
                  this.pause_timeout = timeout(15000, function () { this.pause_timeout = undefined; this.pause(1, PAUSE_TIMEOUT); }.bind(this));
        }
        this.is_paused = function () { this.kick(); return this.paused; };
        this.pause = function (pause, why) {
            pause = !!pause; // normalize to bool
            if (!!this.paused == pause || pause && !this.pausable() ||
                !pause && why && why != PAUSE_BUTTON && this.paused_because != why) { // unpause method must match pause method, undef and PAUSE_BUTTON mean "force".
                this.kick();
                return;
            }
            if (this.paused = pause) {
                this.paused_because = why;
                this.stats.pause();
                if (this.on_pause) this.on_pause();
                if (this.pause_button) this.pause_button.text("Unpause");
            } else {
                this.stats.unpause();
                if (this.on_unpause) this.on_unpause();
                if (this.pause_button) this.pause_button.text("Pause");
                this.kick();
            }
        }
    } else
        this.allow_pause = this.pause = this.is_paused = function () {}
    this.pausable = function () { return this.stats.started(); };

    if (this.activate) {
        this.activate.oncontextmenu = function(e) { return false; }
        this.activate.onmousedown = function(event) {
            if (document.activeElement.tagName.toLowerCase() == 'input') return; // Let the user click out of any text entries that may have the focus
            var e = new plat.event(event);
            if (e.button == plat.left_button)   { this.push_state(); this.complete && this.complete() || this.pop_state(); return false; }
            if (e.button == plat.middle_button) { this.redo_state();                                                       return false; }
            if (e.button == plat.right_button)  { this.undo_state();                                                       return false; }
        }.bind(this);
    }

    // All this for shortcut keys (since accesskeys, above, don't seem to work for me)
    plat.register_key_events(document, maybe_try_wrap(this, function(event) {
        switch (event.key) {
            case 'C-p': case 'M-p': case 'A-p': case 'p': case 'escape': this.pause(!this.paused, PAUSE_BUTTON); return false;
            case 'C-z': case 'M-z': case 'A-z': case 'z': this.undo_state(); return false;
            case 'C-Z': case 'M-Z': case 'A-Z': case 'Z': case 'x': this.redo_state(); return false;
            case 'C-a': case 'M-a': case 'A-a': case 'space': this.push_state(); this.complete && this.complete() || this.pop_state(); return false;
            case 'g': this.push_state(); this.new_game(this.seed); return false;
            case 'n': this.push_state(); this.new_game(); return false;
        }
        return true;
    }, function(e) {
          this.report_error("global key handler", e);
          return true;
    }));
  }

  do_new_game() { this.push_state(); this.new_game(); }
  do_replay() { this.push_state(); this.new_game(this.seed); }
  do_give_up() { this.push_state(); this.end(GAVE_UP); }
  do_high_scores() { this.highscore_alert("High Scores for Game " + this.seed, this.seed); }
  do_show_rules() {
        if (this.instructions.style.display == "block") {
            this.instructions.style.display="none";
            this.show_rules_button.text("Show Rules");
            this.stats.inc("Showed Instructions");
        } else {
            this.instructions.style.display="block";
            this.show_rules_button.text("Hide Rules");
            this.stats.inc("Hid Instructions");
        }
  }
  do_pause_unpause() { this.pause(!this.paused, PAUSE_BUTTON); }
  do_auto_finish() { this.push_state(); this.complete() || this.pop_state(); }
  do_game_of_the_day() { gotd.start_it() }

  extra_error(extra) {
    return merge({   title   : this.name,
                     seed    : this.seed,
                     user    : Login && Login.is_logged_in() ? Login.user : "anonymous"
                 }, extra || {});
  }
  report_error(where, e, extra) {
    return report_error(where, e, this.extra_error(extra));
  }
  bug(where, message, extra) {
    return bug(where, message, this.extra_error(extra));
  }


  update_game_link() {
    if (this.game_link.childNodes.length == 0)
        this.game_link.appendChild(document.createTextNode("safari"));
    if (this.game_link.childNodes[0].data != this.seed) {
        this.game_link.childNodes[0].data = this.seed;
        this.game_link.href = document.URL.split('?')[0] + "?game=" + this.seed;
        this.game_entry.value = this.seed;
    }
  }

  update_difficulty() {
    if (!this.difficulty_el) return;
    doc.clear(this.difficulty_el);
    loadJSON('query/difficulty/'+this.name+'/'+this.seed,
             function(result, error, status) {
                     if (result && result.passable != null)
                         doc.appendTo(this.difficulty_el,
                                      doc.text((result.passable ? "Passable" : result.plays > 20 ? "Hard" : "Unknown") +
                                               (result.plays == 0 ? '' : sprintf(" (%d%%) [%d/%d]", result.wins / result.plays * 100, result.wins, result.plays))));
             }.bind(this));
  }

  new_game(seed) {
    for (var a; a = this.alerts.pop();)
        a.close();
    delete this.ended;
    this.seed = gotd.pick_seed(seed, this.name);
    srand(this.seed);
    this.game_id = Date.now() + Math.random();
    this.update_game_link();
    this.update_difficulty();
    this.update_buttons();
  }

  update_buttons() {
      this.pause_button?.enable(!this.ended);
      this.game_of_the_day_button?.enable(this.seed != gotd.game_of_the_day);
      this.undo_button?.enable(!this.ended && this.undo.length > 0);
      this.redo_button?.enable(!this.ended && this.redo.length > 0);
      this.new_game_button?.enable(true);
      this.replay_button?.enable(true);
      this.give_up_button?.enable(!this.ended && this.is_worth_submitting());
  }

  start_stats() {
    if (this.stats.started())
        this.end_stats();
    this.stats.start();
    this.stats.set("seed", this.seed);
    this.stats.set("game_id", this.game_id);
    this.stats.set("seed_chain", gotd.debug);
    this.update_buttons();
  }

  end_stats() {
      if (!this.is_worth_submitting())
          this.stats.cancel(); // Stop sending us zero move games.
  }

  end_of_move() {
    var complete;
    if (this.is_complete != undefined && (complete = this.is_complete()))
        this.end(complete);
    this.update_buttons();
  }

  // Override to get rid of plays that are not worth clogging the db with
  is_worth_submitting() { return true; }

  // Override these to support undo
  set_state(state) { this.seed = state.seed; this.update_game_link(); this.update_buttons(); }
  get_state() { return { seed: this.seed }; }

  set_stats_state(state) { this.set_state(state.state); this.stats.current = state.stats; }
  get_stats_state(state) { return { state: state || this.get_state(), stats: this.stats.current }; }

  stabilize_state() { this.pause(0); }

  push_state(state) {
    this.stabilize_state();
    var state = this.get_stats_state(state);
    if (!state.state) return;
    this.undo.push(state);
    this.redo = [];
    this.update_buttons();
  }
  pop_state() {
    this.stabilize_state();
    if (this.undo.length > 0) {
        this.set_stats_state(this.undo.pop());
    }
    this.redo = [];
    this.update_buttons();
  }
  undo_state() {
    this.stabilize_state();
    if (this.undo.length > 0) {
        this.stats.inc("undo");
        this.redo.push(this.get_stats_state());
        this.set_stats_state(this.undo.pop());
        this.update_buttons();
    }
  }
  redo_state() {
    this.stabilize_state();
    if (this.redo.length > 0) {
        this.stats.inc("redo");
        this.undo.push(this.get_stats_state());
        this.set_stats_state(this.redo.pop());
        this.update_buttons();
    }
  }
  clear_state() {
    this.undo = [];
    this.redo = [];
    this.update_buttons();
  }

  highscore_alert(title, seed) {
        var div, loading, no_scores;
        this.alerts.push(new Alert(
                  doc(["div",
                       no_scores = doc(["div", { style: { display: 'none' } },
                                        "Sorry, there are no scores for this game yet. ",
                                        this.seed == gotd.game_of_the_day ? {} :
                                        ["span",
                                         "Try playing the ",
                                         ["a", {href:"?game="+gotd.game_of_the_day}, "Game of the day"],
                                         "."]]),
                       ["div",
                        loading=doc(["div", "Loading high score table...", doc.img("spinner.gif")]),
                        div=doc(["div"])
                       ],
                       this.seed != gotd.game_of_the_day ? {} :
                         ["p", { align:"center", style: {fontSize: "x-small"}},
                          ["a", { href: "leader" }, "Check the Leader Board"],
                          " for current game of the day standings."]
                      ]),
                  {goaway:true, title:title}));

        this.the_one_true_highscore_table(div, seed, {repeat: 0}, function(scores, error, retry) {
            loading.style.display = "none";
            if (error) {
                div.appendChild(doc.el("div", {}, doc.text("Error! Couldn't load the high scores ("+String(error)+"). "),
                                       doc.el("a", {href:'#', onclick: function() {retry(); return false;}}, doc.text('Retry?'))));
                return;
            }

            if (scores.length == 0) {
                no_scores.style.display = "";
                div.style.display = "none";
            }
        });
  }

  end(complete) {
    if (this.ended) return; // Should this be an alert to tell the user the game is already submitted?
    this.ended = complete;
    var hs,hs_list,anon_hs,a,loading,db_down,no_hs,error_span,error_p,place_el;
    this.alerts.push(
      this.win = new Alert(
        doc.el("div", {},
               doc.el("p", { align:"center"},
                      doc.text(complete == WON ? "You beat game " : "Better luck next time with game "),
                      doc.el("a", {href: "?game="+this.seed}, doc.text(this.seed)),
                      doc.text(complete == WON ? "!" : ".")),
               loading=doc.el("span", {}, doc.el("p", { align:"center" },
                                                 doc.text("Checking for a high score..."),
                                                 doc.img("spinner.gif"))),
               db_down=doc.el("span", {style: {display:"none"}},
                              doc.el("p", {align:"center", "min-width": "60em" },
                                     doc.text("Your game was saved but our database is currently " +
                                              "undergoing routine maintenance so we can't show you other players' scores."))),
               anon_hs=doc.el("span", {style: { display:"none"}},
                              doc.el("p", { align:"center" }, doc.text("You are not logged in!")),
                              doc.el("p", { align:"center" }, doc.el("a", { onclick: function() { Login.login_dialog(); return false; }, href: "#" },
                                                                     doc.text("Log in")),
                                                              doc.text(" or "), doc.el("a", { onclick: function() { Login.create_dialog(); return false; }, href: "#" },
                                                                     doc.text("register")),
                                                              doc.text(" to get your high score listed in the high score table. ")),
                              doc.el("p", { align:"center",
                                            className: "note",
                                            style: { "min-width": "60em" }
                                          },
                                     doc.text("Don't fear, registration is free! "),
                                     doc.text("Your score will show up under your new name for everyone else "+
                                              "to aspire to and admire with awe and reverence."))),
               error_span=doc.el("span", {style: { display:"none"}},
                                 doc.el("p", { align:"center" }, doc.text("Error!")),
                                 error_p = doc.el("p", { align:"center" })),
               hs_list=doc.el("div", { }),
               this.seed != gotd.game_of_the_day ? undefined :
               doc.el("p", { align:"center", style: {fontSize: "x-small"}},
                      doc.el("a", { href: "leader" }, doc.text("Check the Leader Board")),
                      doc.text(" for current game of the day standings.")),
               doc.el("p", { align:"center"},
                      doc.el("a", { href: makeurl("mailto:", { subject:"I beat this game. Can you?", body: URL.base + "?game=" + this.seed  }) },
                             doc.text("Challenge a friend to this game"))),
               doc.el("p", { align:"center", style: {fontSize: "x-small"}},
                      a=doc.el("a", { href:"close" }, doc.text("Click to close")))),
          {title:place_el=doc(["div", complete == WON ? "Congratulations!" : "Game Over!"]), goaway:true }));
    var got_error = function(message) {
        loading.style.display="none";
        anon_hs.style.display="none";
        error_span.style.display="inline";
        doc.clear(error_p).appendChild(doc.text(message));
    }

    var nth = function(n) {
        if (n%10 == 1 && n%100 != 11) return n+"st";
        if (n%10 == 2 && n%100 != 12) return n+"nd";
        if (n%10 == 3 && n%100 != 13) return n+"rd";
        return n+"th";
    }

    a.onclick = function() { this.win.close(); return false; }.bind(this);
    this.stats.set("complete", complete_text[complete]);
    this.end_stats();
    this.stats.done(function(play_id, error, play) {
        if (error) return got_error(error);
        this.the_one_true_highscore_table(hs_list, this.seed,
                                      !play ? { include:play_id }
                                            : // The server returns "play" back to us only if the DB is down. So fake a high score query that
                                              // just shows the one play.
                                              { fake: [ merge(play, {name: this.name, play_id: "Fake"}) ] },
                                      function(scores, error) {


                                          if (error) return got_error("Your game was saved successfully but the high scores could not be loaded. ("+error+")");
                                          loading.style.display="none";
                                          anon_hs.style.display="none";
                                          error_span.style.display="none";
                                          var place;
                                          for (var i in scores) {
                                              if (scores[i].play_id == play_id) {
                                                  place = scores[i].place;
                                                  if (scores[i].user == "anonymous")
                                                      anon_hs.style.display="inline";
                                                  break;
                                              }
                                          }

                                          if (place && scores[0].total) {
                                              doc.clear(place_el).appendChild(doc.text(sprintf("You placed %s out of %d", nth(place), scores[0].total)));
                                              place_el.style.display="block";
                                          }
                                      });
        if (play) // The DB is down!
            got_error("The server is undergoing maintenance. Your game has been saved and will be added to the high score table when the maintenance is complete.");
    }.bind(this));
    this.update_buttons();
  }


  the_one_true_highscore_table(div, seed, options, callback) {
    options = options || {};
    var query = function() {
        if (options.fake)
            return render(options.fake);
        highscore_seed(this.name, seed, options, function(scores, error) {
            callback(scores, error, query);
            if (error) return;
            render(scores);
        });
    }.bind(this);

    var render = function(scores) {
        render_highscores(doc.clear(div), scores, options.include, true, set_order, options.order);
        doc.appendTo(div,
                     doc(['ul', { style: { "list-style-type": "none", className: "highscore-options"} },
                          ['li',
                           ['label',
                            ['input', { type: "checkbox", checked: !options.best, onclick: function() { set_best(!this.checked) } } ],
                            "Show a player's first score, not their fastest"]],
                          ['li',
                           ['label',
                            ['input', { type: "checkbox", checked: options.anonymous, onclick: function() { set_anonymous(this.checked) } } ],
                            "Show anonymous players"]]]));
    };

    var set_best = function(enabled) {
        Prefs.set("show_best_score", enabled);
        options.best = enabled;
        query();
    };

    var set_anonymous = function(enabled) {
        Prefs.set("show_anonymous", enabled);
        options.anonymous = enabled;
        query();
    };

    var set_order = function(order) {
        Prefs.set("order", order);
        options.order = order;
        query();
    };

    options.best = Prefs.get('show_best_score', true);
    options.anonymous = Prefs.get('show_anonymous', false);
    options.order = Prefs.get('order',           'elapsed');
    query();
  }
}

var NOT_COMPLETE=0, GAME_OVER=1, WON=2, GAVE_UP=3;
var complete_text = [ "NOT_COMPLETE", "GAME_OVER", "WON", "GAVE_UP" ]; // no automatic enums :-(


module.exports = seed_game;
merge_into(module.exports, {
    NOT_COMPLETE: NOT_COMPLETE,
    GAME_OVER:    GAME_OVER,
    WON:          WON,
    GAVE_UP:      GAVE_UP
});
// Copyright (c) 2006-2011 David Caldwell, All Rights Reserved.

var score = require('./score'), stats = score.stats;
var lib = require('./lib'), merge=lib.merge, merge_into=lib.merge_into, srand=lib.srand, rand=lib.rand;
var dom = require('./dom'), doc=dom.doc, URL=dom.URL, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout, Cookie=dom.Cookie;
var plat = require('./platform');
var debug = require('./debug'), maybe_try=debug.maybe_try, maybe_try_wrap=debug.maybe_try_wrap, report_error=debug.report_error, bug=debug.bug;
var ajax = require('./ajax'), loadJSON=ajax.loadJSON, makeurl=ajax.makeurl;
var Alert = require('./alert');
var Prefs = require('./prefs');
var highscore = require('./highscore'), highscore_seed=highscore.highscore_seed, render_highscores=highscore.render_highscores;
var gotd = require('./gotd');
var Login = require('./login');
var prnt = require('./print'), sprintf=prnt.sprintf;

class Button {
    constructor(title, extra, onclick) {
        var disabled = extra.disabled; delete extra.disabled;
        this.div = doc.el("a",
                          merge({ onclick: (e) => { if (!this.disabled) return onclick(e); } },
                                extra),
                          this._text = doc.text(title));
        this.div.classList.add("button");
        this.enable(!disabled);
    }
    text (text) { return text == undefined ? this._text.data : this._text.data = text; }
    enable (enable) { this.div.classList.set(this.disabled = !enable, "disabled"); }
}

const PAUSE_BUTTON=1, PAUSE_BLUR=2, PAUSE_TIMEOUT=3; // Reasons why you might pause.
class seed_game {
  button(opts) {
        if (opts.if && !opts.if()) return;
        let id = opts.id || opts.name.replace(/[^A-Za-z0-9]/g, '_').toLowerCase();
        let _button = new Button(opts.name,
                                 merge({ id: id,
                                         disabled: opts.disabled },
                                       opts.key ? { accessKey: opts.key } : {},
                                       opts.title || opts.key ? { title: opts.help || `Ctrl-${opts.key}` } : {},
                                       opts.accent ? { className: "accent" } : {}),
                                 () => {
                                     maybe_try(() => opts.fn.call(this),
                                               (e) => this.report_error(`${opts.name} button`, e));
                                 });
        this[`${id}_button`] = _button;
        doc.appendTo(this.control_panel, _button.div);
  }
  seed_game_init(name, ui) {
    this.undo = [];
    this.redo = [];
    this.stats = new stats(this.name = name);

    this.activate = ui.activate;
    this.game_el = ui.game || ui.activate;
    this.control_panel = doc(['div', { id: "control_panel" } ]);
    this.game_el.parentNode.insertBefore(this.control_panel, this.game_el);

    this.alerts = [];
    var pause_enabled = this.activate;
    var game = this;
    this.instructions = doc.id("instructions");
    var buttons = [
        {name:"New Game",        fn:this.do_new_game},
        {name:"Replay",          fn:this.do_replay},
        {name:"Give Up",         fn:this.do_give_up},
        {name:"High Scores",     fn:this.do_high_scores},
        {name:"Show Rules",      fn:this.do_show_rules,                                                           if: () => this.instructions },
        {name:"Pause",           fn:this.do_pause_unpause, key:"P",                                               if: () => pause_enabled },
        {name:"Undo",            fn:this.undo_state,       key:"Z", help: "Ctrl-Z or Right-Click",                disabled: true },
        {name:"Redo",            fn:this.redo_state,       key:"E", help: "Ctrl-Shift-Z or Middle-Click",         disabled: true },
        {name:"Shuffle",         fn:this.shuffle,          key:"S",                                               if: () => this.shuffle },
        {name:"Auto-finish",     fn:this.do_auto_finish,   key:"A", help: "Ctrl-A or Left-Click (off any cards)", if: () => this.complete },
        {name:"Game Of The Day", fn:this.do_game_of_the_day, accent: true }
    ];
    buttons.forEach((b) => this.button(b));
    doc.appendTo(this.control_panel,
                 doc(["span",
                      "Game #",
                      ["input", _=>this.game_entry=_,
                       { type:"text", size: 12, id: "game", style:{display:"none"}, onchange: ()=>{
                           var seed = gotd.sane_seed(this.game_entry.value);
                           if (seed != undefined) {
                               this.push_state();
                               this.new_game(seed);
                           } else {
                               this.game_entry.value = this.old_seed;
                               this.old_seed = undefined;
                           }
                           this.game_entry.style.display="none";
                           this.game_link.style.display="inline";
                         }, onblur: ()=>{
                             this.game_entry.style.display="none";
                             this.game_link.style.display="inline";
                         }, onfocus: ()=>{
                             if (this.old_seed == undefined) this.old_seed = this.game_entry.value;
                         }, onkeydown: (event)=>{
                             var e = new plat.key_event(event);
                             if (e.key == "escape") {
                                 this.game_entry.value = this.old_seed;
                                 this.old_seed = undefined;
                                 this.game_entry.style.display="none";
                                 this.game_link.style.display="inline";
                                 return false;
                             }
                             return true;
                         }
                       }
                      ],
                      ["a", _=>this.game_link=_,
                       { href:"safari", id: "link", onclick: ()=>{
                           this.game_entry.style.display="inline";
                           this.game_link.style.display="none";
                           return false;
                       }}
                      ],
                      " ",
                      !URL.param.difficulty ? [] : ["span", _=>this.difficulty_el=_, "Difficulty"]
                     ]));

    if (pause_enabled) {
        this.activate.onmousemove = function () { this.pause(0, PAUSE_TIMEOUT); }.bind(this);
        document.onmousemove = function () { this.kick(); }.bind(this);
        plat.register_window_focus_events(function(focused) { this.pause(!focused, PAUSE_BLUR); }.bind(this));
        this.allow_pause =
        this.kick = function (enable) {
            cancel_timeout(this.pause_timeout);
            if (URL.param.pause || Cookie.list.pause)
              if (enable == undefined || enable)
                  this.pause_timeout = timeout(15000, function () { this.pause_timeout = undefined; this.pause(1, PAUSE_TIMEOUT); }.bind(this));
        }
        this.is_paused = function () { this.kick(); return this.paused; };
        this.pause = function (pause, why) {
            pause = !!pause; // normalize to bool
            if (!!this.paused == pause || pause && !this.pausable() ||
                !pause && why && why != PAUSE_BUTTON && this.paused_because != why) { // unpause method must match pause method, undef and PAUSE_BUTTON mean "force".
                this.kick();
                return;
            }
            if (this.paused = pause) {
                this.paused_because = why;
                this.stats.pause();
                if (this.on_pause) this.on_pause();
                if (this.pause_button) this.pause_button.text("Unpause");
            } else {
                this.stats.unpause();
                if (this.on_unpause) this.on_unpause();
                if (this.pause_button) this.pause_button.text("Pause");
                this.kick();
            }
        }
    } else
        this.allow_pause = this.pause = this.is_paused = function () {}
    this.pausable = function () { return this.stats.started(); };

    if (this.activate) {
        this.activate.oncontextmenu = function(e) { return false; }
        this.activate.onmousedown = function(event) {
            if (document.activeElement.tagName.toLowerCase() == 'input') return; // Let the user click out of any text entries that may have the focus
            var e = new plat.event(event);
            if (e.button == plat.left_button)   { this.push_state(); this.complete && this.complete() || this.pop_state(); return false; }
            if (e.button == plat.middle_button) { this.redo_state();                                                       return false; }
            if (e.button == plat.right_button)  { this.undo_state();                                                       return false; }
        }.bind(this);
    }

    // All this for shortcut keys (since accesskeys, above, don't seem to work for me)
    plat.register_key_events(document, maybe_try_wrap(this, function(event) {
        switch (event.key) {
            case 'C-p': case 'M-p': case 'A-p': case 'p': case 'escape': this.pause(!this.paused, PAUSE_BUTTON); return false;
            case 'C-z': case 'M-z': case 'A-z': case 'z': this.undo_state(); return false;
            case 'C-Z': case 'M-Z': case 'A-Z': case 'Z': case 'x': this.redo_state(); return false;
            case 'C-a': case 'M-a': case 'A-a': case 'space': this.push_state(); this.complete && this.complete() || this.pop_state(); return false;
            case 'g': this.push_state(); this.new_game(this.seed); return false;
            case 'n': this.push_state(); this.new_game(); return false;
        }
        return true;
    }, function(e) {
          this.report_error("global key handler", e);
          return true;
    }));
  }

  do_new_game() { this.push_state(); this.new_game(); }
  do_replay() { this.push_state(); this.new_game(this.seed); }
  do_give_up() { this.push_state(); this.end(GAVE_UP); }
  do_high_scores() { this.highscore_alert("High Scores for Game " + this.seed, this.seed); }
  do_show_rules() {
        if (this.instructions.style.display == "block") {
            this.instructions.style.display="none";
            this.show_rules_button.text("Show Rules");
            this.stats.inc("Showed Instructions");
        } else {
            this.instructions.style.display="block";
            this.show_rules_button.text("Hide Rules");
            this.stats.inc("Hid Instructions");
        }
  }
  do_pause_unpause() { this.pause(!this.paused, PAUSE_BUTTON); }
  do_auto_finish() { this.push_state(); this.complete() || this.pop_state(); }
  do_game_of_the_day() { gotd.start_it() }

  extra_error(extra) {
    return merge({   title   : this.name,
                     seed    : this.seed,
                     user    : Login && Login.is_logged_in() ? Login.user : "anonymous"
                 }, extra || {});
  }
  report_error(where, e, extra) {
    return report_error(where, e, this.extra_error(extra));
  }
  bug(where, message, extra) {
    return bug(where, message, this.extra_error(extra));
  }


  update_game_link() {
    if (this.game_link.childNodes.length == 0)
        this.game_link.appendChild(document.createTextNode("safari"));
    if (this.game_link.childNodes[0].data != this.seed) {
        this.game_link.childNodes[0].data = this.seed;
        this.game_link.href = document.URL.split('?')[0] + "?game=" + this.seed;
        this.game_entry.value = this.seed;
    }
  }

  update_difficulty() {
    if (!this.difficulty_el) return;
    doc.clear(this.difficulty_el);
    loadJSON('query/difficulty/'+this.name+'/'+this.seed,
             function(result, error, status) {
                     if (result && result.passable != null)
                         doc.appendTo(this.difficulty_el,
                                      doc.text((result.passable ? "Passable" : result.plays > 20 ? "Hard" : "Unknown") +
                                               (result.plays == 0 ? '' : sprintf(" (%d%%) [%d/%d]", result.wins / result.plays * 100, result.wins, result.plays))));
             }.bind(this));
  }

  new_game(seed) {
    for (var a; a = this.alerts.pop();)
        a.close();
    delete this.ended;
    this.seed = gotd.pick_seed(seed, this.name);
    srand(this.seed);
    this.game_id = Date.now() + Math.random();
    this.update_game_link();
    this.update_difficulty();
    this.update_buttons();
  }

  update_buttons() {
      this.pause_button?.enable(!this.ended);
      this.game_of_the_day_button?.enable(this.seed != gotd.game_of_the_day);
      this.undo_button?.enable(!this.ended && this.undo.length > 0);
      this.redo_button?.enable(!this.ended && this.redo.length > 0);
      this.new_game_button?.enable(true);
      this.replay_button?.enable(true);
      this.give_up_button?.enable(!this.ended && this.is_worth_submitting());
  }

  start_stats() {
    if (this.stats.started())
        this.end_stats();
    this.stats.start();
    this.stats.set("seed", this.seed);
    this.stats.set("game_id", this.game_id);
    this.stats.set("seed_chain", gotd.debug);
    this.update_buttons();
  }

  end_stats() {
      if (!this.is_worth_submitting())
          this.stats.cancel(); // Stop sending us zero move games.
  }

  end_of_move() {
    var complete;
    if (this.is_complete != undefined && (complete = this.is_complete()))
        this.end(complete);
    this.update_buttons();
  }

  // Override to get rid of plays that are not worth clogging the db with
  is_worth_submitting() { return true; }

  // Override these to support undo
  set_state(state) { this.seed = state.seed; this.update_game_link(); this.update_buttons(); }
  get_state() { return { seed: this.seed }; }

  set_stats_state(state) { this.set_state(state.state); this.stats.current = state.stats; }
  get_stats_state(state) { return { state: state || this.get_state(), stats: this.stats.current }; }

  stabilize_state() { this.pause(0); }

  push_state(state) {
    this.stabilize_state();
    var state = this.get_stats_state(state);
    if (!state.state) return;
    this.undo.push(state);
    this.redo = [];
    this.update_buttons();
  }
  pop_state() {
    this.stabilize_state();
    if (this.undo.length > 0) {
        this.set_stats_state(this.undo.pop());
    }
    this.redo = [];
    this.update_buttons();
  }
  undo_state() {
    this.stabilize_state();
    if (this.undo.length > 0) {
        this.stats.inc("undo");
        this.redo.push(this.get_stats_state());
        this.set_stats_state(this.undo.pop());
        this.update_buttons();
    }
  }
  redo_state() {
    this.stabilize_state();
    if (this.redo.length > 0) {
        this.stats.inc("redo");
        this.undo.push(this.get_stats_state());
        this.set_stats_state(this.redo.pop());
        this.update_buttons();
    }
  }
  clear_state() {
    this.undo = [];
    this.redo = [];
    this.update_buttons();
  }

  highscore_alert(title, seed) {
        var div, loading, no_scores;
        this.alerts.push(new Alert(
                  doc(["div",
                       no_scores = doc(["div", { style: { display: 'none' } },
                                        "Sorry, there are no scores for this game yet. ",
                                        this.seed == gotd.game_of_the_day ? {} :
                                        ["span",
                                         "Try playing the ",
                                         ["a", {href:"?game="+gotd.game_of_the_day}, "Game of the day"],
                                         "."]]),
                       ["div",
                        loading=doc(["div", "Loading high score table...", doc.img("spinner.gif")]),
                        div=doc(["div"])
                       ],
                       this.seed != gotd.game_of_the_day ? {} :
                         ["p", { align:"center", style: {fontSize: "x-small"}},
                          ["a", { href: "leader" }, "Check the Leader Board"],
                          " for current game of the day standings."]
                      ]),
                  {goaway:true, title:title}));

        this.the_one_true_highscore_table(div, seed, {repeat: 0}, function(scores, error, retry) {
            loading.style.display = "none";
            if (error) {
                div.appendChild(doc.el("div", {}, doc.text("Error! Couldn't load the high scores ("+String(error)+"). "),
                                       doc.el("a", {href:'#', onclick: function() {retry(); return false;}}, doc.text('Retry?'))));
                return;
            }

            if (scores.length == 0) {
                no_scores.style.display = "";
                div.style.display = "none";
            }
        });
  }

  end(complete) {
    if (this.ended) return; // Should this be an alert to tell the user the game is already submitted?
    this.ended = complete;
    var hs,hs_list,anon_hs,a,loading,db_down,no_hs,error_span,error_p,place_el;
    this.alerts.push(
      this.win = new Alert(
        doc.el("div", {},
               doc.el("p", { align:"center"},
                      doc.text(complete == WON ? "You beat game " : "Better luck next time with game "),
                      doc.el("a", {href: "?game="+this.seed}, doc.text(this.seed)),
                      doc.text(complete == WON ? "!" : ".")),
               loading=doc.el("span", {}, doc.el("p", { align:"center" },
                                                 doc.text("Checking for a high score..."),
                                                 doc.img("spinner.gif"))),
               db_down=doc.el("span", {style: {display:"none"}},
                              doc.el("p", {align:"center", "min-width": "60em" },
                                     doc.text("Your game was saved but our database is currently " +
                                              "undergoing routine maintenance so we can't show you other players' scores."))),
               anon_hs=doc.el("span", {style: { display:"none"}},
                              doc.el("p", { align:"center" }, doc.text("You are not logged in!")),
                              doc.el("p", { align:"center" }, doc.el("a", { onclick: function() { Login.login_dialog(); return false; }, href: "#" },
                                                                     doc.text("Log in")),
                                                              doc.text(" or "), doc.el("a", { onclick: function() { Login.create_dialog(); return false; }, href: "#" },
                                                                     doc.text("register")),
                                                              doc.text(" to get your high score listed in the high score table. ")),
                              doc.el("p", { align:"center",
                                            className: "note",
                                            style: { "min-width": "60em" }
                                          },
                                     doc.text("Don't fear, registration is free! "),
                                     doc.text("Your score will show up under your new name for everyone else "+
                                              "to aspire to and admire with awe and reverence."))),
               error_span=doc.el("span", {style: { display:"none"}},
                                 doc.el("p", { align:"center" }, doc.text("Error!")),
                                 error_p = doc.el("p", { align:"center" })),
               hs_list=doc.el("div", { }),
               this.seed != gotd.game_of_the_day ? undefined :
               doc.el("p", { align:"center", style: {fontSize: "x-small"}},
                      doc.el("a", { href: "leader" }, doc.text("Check the Leader Board")),
                      doc.text(" for current game of the day standings.")),
               doc.el("p", { align:"center"},
                      doc.el("a", { href: makeurl("mailto:", { subject:"I beat this game. Can you?", body: URL.base + "?game=" + this.seed  }) },
                             doc.text("Challenge a friend to this game"))),
               doc.el("p", { align:"center", style: {fontSize: "x-small"}},
                      a=doc.el("a", { href:"close" }, doc.text("Click to close")))),
          {title:place_el=doc(["div", complete == WON ? "Congratulations!" : "Game Over!"]), goaway:true }));
    var got_error = function(message) {
        loading.style.display="none";
        anon_hs.style.display="none";
        error_span.style.display="inline";
        doc.clear(error_p).appendChild(doc.text(message));
    }

    var nth = function(n) {
        if (n%10 == 1 && n%100 != 11) return n+"st";
        if (n%10 == 2 && n%100 != 12) return n+"nd";
        if (n%10 == 3 && n%100 != 13) return n+"rd";
        return n+"th";
    }

    a.onclick = function() { this.win.close(); return false; }.bind(this);
    this.stats.set("complete", complete_text[complete]);
    this.end_stats();
    this.stats.done(function(play_id, error, play) {
        if (error) return got_error(error);
        this.the_one_true_highscore_table(hs_list, this.seed,
                                      !play ? { include:play_id }
                                            : // The server returns "play" back to us only if the DB is down. So fake a high score query that
                                              // just shows the one play.
                                              { fake: [ merge(play, {name: this.name, play_id: "Fake"}) ] },
                                      function(scores, error) {


                                          if (error) return got_error("Your game was saved successfully but the high scores could not be loaded. ("+error+")");
                                          loading.style.display="none";
                                          anon_hs.style.display="none";
                                          error_span.style.display="none";
                                          var place;
                                          for (var i in scores) {
                                              if (scores[i].play_id == play_id) {
                                                  place = scores[i].place;
                                                  if (scores[i].user == "anonymous")
                                                      anon_hs.style.display="inline";
                                                  break;
                                              }
                                          }

                                          if (place && scores[0].total) {
                                              doc.clear(place_el).appendChild(doc.text(sprintf("You placed %s out of %d", nth(place), scores[0].total)));
                                              place_el.style.display="block";
                                          }
                                      });
        if (play) // The DB is down!
            got_error("The server is undergoing maintenance. Your game has been saved and will be added to the high score table when the maintenance is complete.");
    }.bind(this));
    this.update_buttons();
  }


  the_one_true_highscore_table(div, seed, options, callback) {
    options = options || {};
    var query = function() {
        if (options.fake)
            return render(options.fake);
        highscore_seed(this.name, seed, options, function(scores, error) {
            callback(scores, error, query);
            if (error) return;
            render(scores);
        });
    }.bind(this);

    var render = function(scores) {
        render_highscores(doc.clear(div), scores, options.include, true, set_order, options.order);
        doc.appendTo(div,
                     doc(['ul', { style: { "list-style-type": "none", className: "highscore-options"} },
                          ['li',
                           ['label',
                            ['input', { type: "checkbox", checked: !options.best, onclick: function() { set_best(!this.checked) } } ],
                            "Show a player's first score, not their fastest"]],
                          ['li',
                           ['label',
                            ['input', { type: "checkbox", checked: options.anonymous, onclick: function() { set_anonymous(this.checked) } } ],
                            "Show anonymous players"]]]));
    };

    var set_best = function(enabled) {
        Prefs.set("show_best_score", enabled);
        options.best = enabled;
        query();
    };

    var set_anonymous = function(enabled) {
        Prefs.set("show_anonymous", enabled);
        options.anonymous = enabled;
        query();
    };

    var set_order = function(order) {
        Prefs.set("order", order);
        options.order = order;
        query();
    };

    options.best = Prefs.get('show_best_score', true);
    options.anonymous = Prefs.get('show_anonymous', false);
    options.order = Prefs.get('order',           'elapsed');
    query();
  }
}

var NOT_COMPLETE=0, GAME_OVER=1, WON=2, GAVE_UP=3;
var complete_text = [ "NOT_COMPLETE", "GAME_OVER", "WON", "GAVE_UP" ]; // no automatic enums :-(


module.exports = seed_game;
merge_into(module.exports, {
    NOT_COMPLETE: NOT_COMPLETE,
    GAME_OVER:    GAME_OVER,
    WON:          WON,
    GAVE_UP:      GAVE_UP
});
